import React, { useContext, useEffect, useState } from 'react'
// import Logo from '../../assets/images/nest-logo-white.svg'
import Logo from '../../assets/images/logo-risen-ats.svg'
import RisenLogo from '../../assets/images/logo-risen.png'
import LogoIcon from '../../assets/images/logo-risen-icon.png'
import { Layout, Button, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { GroupOutlined, HomeOutlined, MenuOutlined } from '@ant-design/icons';
import useWindowDimensions from '../Utility/useWindowDimensions';
import { AuthContext } from '../Context/AuthContext';

const { Sider } = Layout;
function Sidebar({ collapsed, setCollapsed }) {
    const auth = useContext(AuthContext);
    const { SubMenu } = Menu;
    const [current, setCurrent] = useState('/');
    const [submenu, setSubmenu] = useState(['/application']);

    const location = useLocation();


    useEffect(() => {
        const openSubmenu = location.pathname.split('/')[1];
        setSubmenu(['/' + openSubmenu + '/']);
        setCurrent(location.pathname);

    }, [location])


    return (
        <Sider
            className='sidebar-wrapper'
            trigger={null}
            collapsible
            collapsed={collapsed}
            breakpoint="sm"
            onMouseEnter={() => setCollapsed(false)}
            onMouseLeave={() => setCollapsed(true)}
        >
            <div className='sidebar-logo'>
                <img src={Logo} alt='logo' />
            </div>
            <div className='navigation-wrapper'>
                <Menu
                    theme="dark"
                    mode="inline"
                    inlineIndent="20"
                    selectedKeys={current}
                    //defaultSelectedKeys={['/']}
                    // defaultOpenKeys={!collapsed ? ['/application'] : []}
                    openKeys={!collapsed ? submenu : []}
                    //selectedKeys={[current]}
                    /* onOpenChange={(openKeys) => {
                        setSubmenu(openKeys);
                    }} */
                    onOpenChange={(openKeys) => {
                        setSubmenu(openKeys);
                    }}
                //onClick={(item) => isMobile && setSidebarState(true)}
                >
                    <Menu.Item key="/" icon={<HomeOutlined />}  >
                        <Link to="/">
                            Dashboard
                        </Link>
                    </Menu.Item>
                    <SubMenu key="/application" icon={<GroupOutlined />} title="Application">
                        <Menu.Item key="/create-application">
                            <Link to="/create-application"> New Application</Link>
                        </Menu.Item>
                        <Menu.Item key="/application-list">
                            <Link to="/application-list"> My Applications</Link>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </div>

            <Button className='toggle-nav-btn' icon={<MenuOutlined />} onClick={() => setCollapsed(!collapsed)} />

            <div className='sidebar-footer-logo'>
                <img src={RisenLogo} alt='logo' />
                <p>&copy; 2023, All rights reserved</p>
            </div>
            {/* <div className='sidebar-logout'>
                <Button type='text' style={{ color: '#fff' }} onClick={auth.handleLogout}>Logout</Button>
            </div> */}
        </Sider>
    )
}

export default Sidebar